import { createFileRoute } from "@tanstack/react-router";
import { metadataHead } from "src/lib/Metadata";
import MaintenancePage from "src/routes/-components/MaintenancePage";

// Where the maintenance gate sends everyone (src/server/SiteMiddleware.ts).
export const Route = createFileRoute("/maintenance")({
  head: () =>
    metadataHead({ title: "Scheduled maintenance", robots: { index: false, follow: true } }),
  component: MaintenancePage,
});
